import { render } from "./appui.vue?vue&type=template&id=64dd37e1"
import script from "./appui.vue?vue&type=script&lang=js"
export * from "./appui.vue?vue&type=script&lang=js"

import exportComponent from "D:\\portfolio\\bhavindabhi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__